import React, { useEffect } from 'react';
import { Select } from 'antd';

import { Office } from '../../../models/Office';
import { useDispatch } from 'react-redux';
import { fetchExternalOffices, fetchInternalOffices } from '../actions';
import classNames from 'classnames';
import { makePrioStyles } from '../../../theme/utils';
import { OfficeId } from '../../../models/Types';
import useOfficesContext from '../hooks/useOfficesContext';

const useStyles = makePrioStyles((theme) => ({
  root: { width: '100%' },
  disabledPicker: {
    backgroundColor: 'rgb(0,0,0,0.05)',
  },
}));
interface OfficePickerProps {
  defaultValue?: string | string[];
  value?: string | string[];
  label?: string;
  onChange?: (value: string | string[]) => void;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  onlyInternal?: boolean;
  multiple?: boolean;
  fetch?: boolean;
  officeIds?: OfficeId[];
  className?: string;
}

export const OfficePicker: React.FC<OfficePickerProps> = (props) => {
  const classes = useStyles();
  const {
    className,
    value,
    label,
    onChange,
    disabled,
    readonly,
    onlyInternal,
    multiple,
    defaultValue,
    officeIds,
  } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!onlyInternal) {
      dispatch(fetchExternalOffices());
    }
    dispatch(fetchInternalOffices());
  }, [dispatch, onlyInternal]);

  const { internalOffices, allOffices, getOfficeById } = useOfficesContext();
  const offices = onlyInternal ? internalOffices : allOffices;

  const officesLimited = officeIds?.map((officeId) => getOfficeById(officeId));

  const handleOnChange: (value: string) => void = onChange
    ? (value: string) => {
        onChange(value ?? '');
      }
    : null;

  return (
    <Select
      className={classNames(classes.root, className, {
        [classes.disabledPicker]: disabled,
      })}
      showSearch
      mode={multiple ? 'multiple' : null}
      value={value}
      defaultValue={defaultValue}
      placeholder={label}
      optionFilterProp="children"
      onChange={handleOnChange}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      filterOption={(input, option) =>
        option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      disabled={disabled || readonly}
      options={(officesLimited ?? offices)?.map((office: Office) => ({
        value: office.officeId,
        label: office.name ?? '???',
        title: office.name ?? '???',
      }))}
    />
  );
};

export default OfficePicker;
